import { NgModule } from '@angular/core';
import { DecimalEuroPipe } from "src/app/pipes/decimal-euro.pipe";
import { CurrencyPipe } from "@angular/common";
import { DecimalPipe } from "@angular/common";
import { EmptyCheckPipe } from "src/app/pipes/empty-check.pipe";
import { PhoneNumberPipe } from "src/app/pipes/phone-number.pipe";
import { SiretPipe } from "src/app/pipes/siret-pipe";
import { NirPipe } from "src/app/pipes/nir-pipe";

@NgModule( {
    declarations: [DecimalEuroPipe, EmptyCheckPipe, PhoneNumberPipe, SiretPipe, NirPipe],
    exports: [DecimalEuroPipe, EmptyCheckPipe, PhoneNumberPipe, SiretPipe, NirPipe],
    imports: [],
    providers: [CurrencyPipe, DecimalPipe, EmptyCheckPipe, PhoneNumberPipe, SiretPipe, NirPipe]
} )
export class PipesModuleModule { }

